import React from "react";
import { Typography } from "top-brains-ui";
import styles from "@src/pages/login/reset-link-success/ResetLinkSuccess.module.scss";
import resetLink from "@src/assets/reset-link-success.svg";
import { useLocation, useNavigate } from "react-router-dom";
import GradiantButton from "@src/components/gradiant-btn/GradiantButton";
import { setUserLogin } from "@src/app/globalSlice";
import { useDispatch } from "react-redux";
// import { WEBSITE_COLORS } from "@src/styles/ColorConstants";

const ResetLinkSuccess: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location?.state?.email;

  const handleSignInClick = () => {
    navigate("/");
    dispatch(setUserLogin(true));
  };
  return (
    <div className={styles.container}>
      <div className={styles.msgTitle}>
        <Typography fontWeight="semi-bold" fontSize={24} color="var(--modal-heading-color)" className={styles.resetLink}>
          Reset Link sent Successfully !
        </Typography>
      </div>
      <div>
        <img src={resetLink} alt="password_link_img" />
      </div>

      <div className={styles.msgBody}>
        <div className={styles.msgContent}>
          <Typography fontSize={16} color="var(--modal-body-color)">
            An email has been sent to{" "}
            <Typography color="var(--login-text-color)" fontSize={16}>
              {email}
            </Typography>
            . Kindly check your inbox for the reset link.
          </Typography>
        </div>
      </div>
      <div className={styles.btnStyle}>
        <GradiantButton
          variant="primary"
          width="400px"
          height="44px"
          fontSize={16}
          labelClassName={styles.buttonLabel}
          className={styles.button}
          label="Back to Sign In"
          onClick={handleSignInClick}
        />
      </div>
    </div>
  );
};

export default ResetLinkSuccess;
